
import Api from '@/utils/api';
import MHeader from '../Header/Header.vue';
import NoData from '../NoData/NoData.vue';

import Divider from 'vux/src/components/divider/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'

export default {
components: {
MHeader,
Divider,
Scroller,
LoadMore,
NoData,
Popup,
Group,
Radio,
XTextarea,
Confirm,
ViewBox,
Actionsheet,
XDialog,
Tab,
TabItem,
Timeline,
TimelineItem
},
directives: {
TransferDom
},
data() {
return {
isLoadMore: false,
showLoad: false,
list: []
}
},
methods: {
back() {
this.$router.replace({
name: 'userCenter'
});
},
totalCount(order) {
let count = 0
_.forEach(order.products, (product) => {
count += product.quantity
})
return count
},
toDetail(order) {
this.$router.push({
name: 'orderDetail',
params: {
tid: order._id
}
});
},
loadList() {
Api.getOrderShipment()
.then((res) => {
this.list = res.data
})
}
},
created() {
this.h = document.documentElement.clientHeight - 0.88 * (document.documentElement.clientWidth / 7.5) + 'px';
this.loadList()
},
computed: {},
filters: {}
}



// WEBPACK FOOTER //
// ./src/components/OrderList/Shipment.vue